import { render, staticRenderFns } from "./addFixedAsstes.vue?vue&type=template&id=0cd4a7a4"
import script from "./addFixedAsstes.vue?vue&type=script&lang=js"
export * from "./addFixedAsstes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports